var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBusinessCashFlow64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BusinessCashflow64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pictogramCashFlow64.ca2212a5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BusinessCashflow",
    transform: "translate(9.000000, 6.118250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shares",
    transform: "translate(1.804583, 0.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.86208333,
    y1: 26.2052794,
    x2: 36.52875,
    y2: 4.55822059,
    id: "Line-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9579167,3.31250003 C34.9579167,1.48190791 36.4398245,0 38.2704166,0 C40.1010087,0 41.5829167,1.48190791 41.5829167,3.31250003 C41.5829167,5.14309214 40.1010087,6.62500006 38.2704166,6.62500006 C36.4398245,6.62500006 34.9579167,5.14309214 34.9579167,3.31250003 Z",
    id: "Point-4",
    fill: "#FFCC00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.225,15.1138333 C17.225,13.2832412 18.7069079,11.8013333 20.5375,11.8013333 C22.3680921,11.8013333 23.85,13.2832412 23.85,15.1138333 C23.85,16.9444254 22.3680921,18.4263333 20.5375,18.4263333 C18.7069079,18.4263333 17.225,16.9444254 17.225,15.1138333 Z",
    id: "Point-2",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.31250002,30.99175 C1.4819079,30.99175 0,29.5098422 0,27.67925 C0,25.8486579 1.4819079,24.36675 3.31250002,24.36675 C5.14309214,24.36675 6.62500005,25.8486579 6.62500005,27.67925 C6.62500005,29.5098422 5.14309214,30.99175 3.31250002,30.99175",
    id: "Point-1",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bars",
    transform: "translate(23.500000, 32.715084) scale(-1, 1) translate(-23.500000, -32.715084) translate(0.000000, 12.548417)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#4F4C4D",
    points: "0 38.3333333 47 38.3333333 47 40.3333333 0 40.3333333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bar",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFCC00",
    x: 1,
    y: 0,
    width: 11,
    height: 39.3333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bar",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 19,
    y: 11.1944444,
    width: 11,
    height: 28.1388889
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bar",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 36,
    y: 24.9722222,
    width: 11,
    height: 14.3611111
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBusinessCashFlow64);
export default __webpack_public_path__ + "static/media/pictogramBusinessCashFlow64.faa3ad288515a18f7d44b3a8b0b7393c.svg";
export { ForwardRef as ReactComponent };